import { getCreatorDefsites } from "./divideDefsitesByOrigin";
import { GetPageContentBlock, ParseElementIncludesFromContentBlock, ParseElementIncludesFromHomePageContentBlock, GetFooterBlock } from "./liquidXmlParser/liquidXmlParser";
import { saveCurrentState, generateUniqueName } from "./listChanging";
import { getPluginConfigMaps } from "./liquidXmlParser/liquidXmlPlugins";
import { defaultBannerNamePrefix } from "../config/defaults";
import { getElementSettings, getColumnElementSettings, changeRecomendedNameAndSetType } from '../templates/_templatesMap';

function parseCreatorGlobalElements(xmlString, pluginConfigMap, templateTempContent) {
    const globalElements = require('../assets/elements.json').globalTypes;

    globalElements.forEach(blockName => {
        let blockContent;
        //TODO fix it when refactoring defsites
        //if (blockName === 'header') GetHeaderBlock(xmlString, '_layout.html'); - situation to call this condition when header will be splitted yet (remember about import from "./liquidXmlParser/liquidXmlParser")
        if (blockName === 'footer') {
            blockContent = GetFooterBlock(xmlString, '_layout.html');
        }
        else if (blockName === 'header'  || blockName === 'column' ) {
            blockContent = " ";
        }
        else {
            //when importing new "global block" in layout, new logic is needed for importing, 
            //it's not possible to predict whether or not it will be needed in the future, so warning will suffice
            console.warn("unexpected global element type definition in assets/elements.json, will not process");
            return;
        }
        if (!blockContent) { return; }
        const globals = ParseElementIncludesFromContentBlock(blockContent, pluginConfigMap, blockName, templateTempContent);
        templateTempContent = {...templateTempContent, [blockName]: globals};
        this.setState({ [blockName]: globals });
        saveCurrentState.call(this, blockName, globals);
    })
}


const HighestBannerId = (pageBody) => Math.max(//return max id of spread array:
    ...(pageBody.filter(//interested in elements that have name like `${bannerPrefix}${id}`
        k => k.name && new RegExp(`^${defaultBannerNamePrefix}([0-9]+)$`).test(k.name)
    ).map(//extract banner id
        k => parseInt(k.name.slice(defaultBannerNamePrefix.length), 10)
    ).filter(//filter NaNs just in case
        k => !isNaN(k)
    )
    )
)


/**
 * 
 * @param {string} xmlString 
 * @param {Set} templateNames 
 */
function parseCreatorSitesContent(xmlString, templateNames) {
    const creatorDefSites = getCreatorDefsites();
    let templateTempContent = {};
    const pluginConfigMap = getPluginConfigMaps.call(this, xmlString);
    let isRecommendedError = false;
	let recommendedErrorPageName, recommendedErrorId = '';
    creatorDefSites.forEach(site => {
        if (!templateNames.has(site.name)) { return; }
        const pageContent = GetPageContentBlock(xmlString, site.name);
        let pageBody;
        let recError, recErrorType;

        if(site.listName === 'mainBody') {
            pageBody = ParseElementIncludesFromHomePageContentBlock(pageContent, pluginConfigMap);
        } else {
            pageBody = ParseElementIncludesFromContentBlock(pageContent, pluginConfigMap, site.listName);
        }

        const bodyHighestBannerId = HighestBannerId(pageBody);
        if (this.counter.banner <= bodyHighestBannerId) {
            this.counter.banner = bodyHighestBannerId + 1;
        }

        templateTempContent = {...templateTempContent, [site.listName]: pageBody};
        this.setState({ [site.listName]: pageBody });
        saveCurrentState.call(this, site.listName, pageBody);

        if(recError === true) {
            isRecommendedError = true;
            recommendedErrorPageName = site.listName;
            recommendedErrorId = recErrorType;
        }
    });

    parseCreatorGlobalElements.call(this, xmlString, pluginConfigMap, templateTempContent);

    //open _layout.html
    //get header, footer blocks
    //save each to respective field in creator
    //or if not found, make empty site
    return [isRecommendedError, recommendedErrorPageName, recommendedErrorId];
}

function parseCreatorGlobalElementsOnTemplateSelection(templateSettings) {
    const globalElements = require('../assets/elements.json').globalTypes;
    let blockContent;

    globalElements.forEach(blockName => {
        if (blockName === 'header') {
            blockContent = getElementSettings([templateSettings[blockName]]);
        }
        else if (blockName === 'column') {
            blockContent = getColumnElementSettings.call(this);
        }
        else if (blockName === 'footer') {
            blockContent = getElementSettings([templateSettings[blockName]]);
        }
        else {
            console.warn("unexpected global element type definition in assets/elements.json, will not process");
            return;
        }
        if (!blockContent) { return; }

        this.setState({ [blockName]: blockContent });
        saveCurrentState.call(this, blockName, blockContent);
    })
}

function parseCreatorSitesContentOnTemplateSelection(templateSettings) {
    const creatorDefSites = getCreatorDefsites();

    creatorDefSites.forEach( site => {
        if (!templateSettings[site.listName]) { return; }
        const pageBody = getElementSettings(templateSettings[site.listName]);
        pageBody.forEach( body => {
            changeRecomendedNameAndSetType.call(this, body, site.listName);
            generateUniqueName.call(this, body, site.listName);
        });
        const bodyHighestBannerId = HighestBannerId(pageBody);
        if (this.counter.banner <= bodyHighestBannerId) {
            this.counter.banner = bodyHighestBannerId + 1;
        }

        this.setState({ [site.listName]: pageBody });
        saveCurrentState.call(this, site.listName, pageBody);
    });

    parseCreatorGlobalElementsOnTemplateSelection.call(this, templateSettings);
}

export { parseCreatorSitesContent, parseCreatorSitesContentOnTemplateSelection };